import {useEffect, useState} from 'react';
import {useParams, Link, useLocation} from 'react-router-dom';
import {Col, Divider, Empty, Row, Spin, Typography} from 'antd';
import moment from 'moment-timezone';
import {StudentsService} from './StudentsService';

const studentsService = new StudentsService();

export const UserDetails = () => {
  const [user, setUser] = useState<any>(undefined);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const params: {userId: string} = useParams();
  const {Title, Text} = Typography;
  const location = useLocation();

  useEffect(() => {
    studentsService
      .getUserById(params.userId)
      .then(resp => {
        setIsLoading(false);
        setUser(resp);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [location.pathname]);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>User Details</Title>

      {!isError && !isLoading && (
        <>
          <Row>
            <Col span={24}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  User ID
                </Text>
                <Text style={{display: 'block'}}>{user?.id}</Text>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Email
                </Text>
                <Text style={{display: 'block'}}>{user?.email ?? '-'}</Text>
              </div>
            </Col>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Whatsapp Number
                </Text>
                <Text style={{display: 'block'}}>
                  {user?.whatsappNumber ?? '-'}
                </Text>
              </div>
            </Col>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Timezone
                </Text>
                <Text style={{display: 'block'}}>{user?.timeZone ?? '-'}</Text>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Device
                </Text>
                <Text style={{display: 'block'}}>
                  {user?.devicePlatform ?? '-'}
                </Text>
              </div>
            </Col>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Country
                </Text>
                <Text style={{display: 'block'}}>{user?.country ?? '-'}</Text>
              </div>
            </Col>
            <Col span={8}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Cognito ID
                </Text>
                <Text style={{display: 'block'}}>
                  {user?.cognitoUserId ?? '-'}
                </Text>
              </div>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text
                  style={{display: 'block', marginBottom: 15, fontSize: 20}}
                  strong={true}>
                  User Students
                </Text>
                {!user?.students?.length && (
                  <Empty description="No linked students" />
                )}
                {user?.students?.map((student: any) => (
                  <div key={student._id ?? student.id}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                      <div style={{display: 'flex', flexDirection: 'column'}}>
                        <Text style={{fontSize: 15, fontWeight: 'bold'}}>
                          Student Name: {student.name}
                        </Text>
                        <Text style={{fontSize: 15}}>
                          Joined At:{' '}
                          {student.createdAt
                            ? moment(student.createdAt).format('YYYY-MM-DD')
                            : '-'}
                        </Text>
                        <Text style={{fontSize: 15}}>
                          School ID: <b>{student.schoolId ?? '-'}</b>
                        </Text>
                        <Link
                          to={
                            '/students/' + (student._id ?? student.id) + '/edit'
                          }>
                          {student._id ?? student.id}
                        </Link>
                      </div>
                    </div>
                    <Divider />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </>
      )}

      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>User fetching error</Title>}
    </div>
  );
};
